<div class="d-flex headerClass fx-row">
  <div class="fx-row fx-main-start fx-cross-center fx-flex-20 xs-fx-flex-15">
    <p class="margin-img">
      <a class="c-white logo"><img src="../../../../assets/images/logo_small.png" class="width-img" />
      </a>
    </p>
  </div>
  <div class="fx-row fx-main-center lt-md-fx-main-end fx-cross-center fx-flex-60">
    <div class="text-center sim-m-t-10 c-white">
      <span>{{'Checkout' | translate}}</span>
      <span class="text-lowercase">{{'(' + getQuanity() + ' ' + 'items' + ')' }}</span>
    </div>

  </div>
  <div class="fx-row fx-main-start fx-cross-center fx-flex-20 xs-fx-flex-15">
    <span class="sim-m-t-10 c-white">
      {{'Language' | translate}}:
      <select (change)="languageChanged($event)">
        @for (lng of languages; track lng) {
          <option
          [value]="lng">{{lng.toUpperCase()}}</option>
        }
      </select>
    </span>
  </div>
</div>
<div id="application">
  <div class="main fx-row lt-lg-fx-col" style="position: relative;">
    <div class="firstContent fx-col lt-lg-fx-flex-100-in-col print-fx-flex-70 gt-md-fx-flex-70">
      <div class="m-b-30 fx-col fx-main-start fx-cross-stretch">
        <div class="fx-flex-100-in-col">
          <span class="headingTitle-f-s-30" translate="unified_welcome_title"></span>
        </div>
        <div class="fx-flex-100-in-col">
          <span class="subTitle-f-s-16" translate="unifiedapplication_complete_the_fields_below"></span>
        </div>
      </div>
      <div>
        @if (!userService.sponsorSectionPanel) {
          <mat-card appearance="outlined" class="p-7 firstcard fx-row">
            <div class="fx-row xs-fx-col fx-flex-100">
              <div class="fx-row xs-fx-flex-100-in-col print-fx-flex-61 gt-xs-fx-flex-61">
                <div class="headerLogo">
                  <a class="">
                    <img class="avtar" alt="companylogo" [src]="userService.enrollerInfo.ImageUrl">
                  </a>
                </div>
                <div class="enroll_info">
                  <span class="companyLabel" translate="you_r_shop_with"></span><br>
                  <span class="text-uppercase"
                  [textContent]="userService.enrollerInfo.FirstName + ' ' + userService.enrollerInfo.LastName"></span>
                </div>
              </div>
              <div class="fx-row xs-fx-flex-100-in-col print-fx-flex-39 gt-xs-fx-flex-39">
                <div class="fx-col fx-main-center fx-cross-stretch fx-flex-51">
                  @if (!userService.customerTypeID) {
                    <div class="fx-row fx-main-start fx-cross-stretch">
                      <span class="companyName" translate="shop_as"></span>
                    </div>
                  }
                  <div class="fx-row fx-main-start fx-cross-stretch">
                    <span class="text-uppercase" [textContent]="customerTypeDescription()"></span>
                  </div>
                </div>
                <div class="fx-row fx-main-end fx-cross-center fx-flex-49">
                  <div class="borderLeft fx-flex-5">
                  </div>
                  <div class="fx-row fx-main-end fx-cross-center fx-flex-70 xs-fx-flex-43">
                    <div class="fx-row fx-main-start fx-cross-center"
                      [ngClass]="{'is-clicked' : true, 'mat-icon-collapsed' : true}">
                      @if (selectedCountry) {
                        <span data-bind="label">
                          <img class="flag-icon"
                            [src]="'https://directscalestring.directscale.com/flags/4x3/' + country.CountryCode + '.svg'"
                            onerror="this.src='assets/images/noimage.png'">
                            <span class="text-nonecase"
                            data-bind="label">{{country.CountryCode.toUpperCase()}}</span>
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card>
          }
          <mat-expansion-panel class="fx-row-in-expansion-panel" [expanded]="userService.sponsorSectionPanel"
            (opened)="panelShippingAddress = true ;isPanelOpen= true"
            (closed)="panelShippingAddress = false ;isPanelOpen = false">
          <div class="fx-col fx-flex-100">
            <div class="m-b-10 p-t-20 fx-col fx-flex-100-in-col">
              <div class="fx-row fx-flex-100-in-col">
                <div class="fx-flex-95">
                  <span class="color-f-s-15 f-bold"
                  translate="unifiedapplication_verify_status"></span>
                </div>
                <div class="editIcon fx-row fx-main-end fx-cross-stretch fx-flex-5">
                  @if (userService.sponsorSectionPanel) {
                    <mat-icon class="c-gray"
                      (click)="togglePanel()">keyboard_arrow_down
                    </mat-icon>
                  }
                </div>
              </div>
              <div>
                <span class="color-f-s-12" translate="unifiedapplication_review_continue"></span>
              </div>
            </div>
            <mat-divider></mat-divider>
            <div
              class="p-t-b-7 fx-row xs-fx-col fx-main-between fx-cross-stretch fx-flex-100-in-col">
              <div class="fx-row fx-main-between fx-cross-center xs-fx-flex-100-in-col print-fx-flex-49 gt-xs-fx-flex-49">
                <div class="fx-row fx-main-start fx-cross-center fx-flex-42 md-fx-flex-30">
                  <span class="color-f-s-11"
                  translate="unifiedapplication_you_purchasing_from"></span>
                </div>
                <div class="fx-row fx-main-between xs-fx-main-end fx-cross-center xs-fx-cross-stretch fx-flex-56 md-fx-flex-40"
                  >
                  <div class="headerLogo fx-row fx-main-start fx-cross-center fx-flex-10 xs-fx-flex-20">
                    <a class="">
                      <img class="avtar" alt="companylogo"
                        [src]="userService.enrollerInfo.ImageUrl">
                    </a>
                  </div>
                  <div class="fx-flex-80 xs-fx-flex-64">
                    <button mat-button (click)="changeAffiliate()"
                      [textContent]="userService.enrollerInfo.FirstName + ' ' + userService.enrollerInfo.LastName">
                      <mat-icon>
                      keyboard_arrow_down</mat-icon>
                    </button>
                  </div>
                </div>
                <div class="fx-flex-0 md-fx-flex-27"></div>
              </div>
              <div class="fx-row fx-main-end fx-cross-stretch xs-fx-flex-100-in-col print-fx-flex-49 gt-xs-fx-flex-49">
                <div class="fx-flex-0 md-fx-flex-4"></div>
                <div class="fx-row fx-main-start md-fx-main-end fx-cross-center fx-flex-55 xs-fx-flex-65 sm-fx-flex-50 md-fx-flex-60"
                  >
                  <span translate="unifiedapplication_region_language"></span>
                </div>
                @if (country) {
                  <div
                    class="samSpaceButton fx-row fx-main-end fx-cross-center fx-flex-40 xs-fx-flex-39 sm-fx-flex-33 md-fx-flex-30">
                    <button mat-button>
                      <img class="flag-icon"
                        [src]="'https://directscalestring.directscale.com/flags/4x3/'+ country.CountryCode +'.svg'"
                        onerror="this.src='assets/images/noimage.png'">
                        <span class="flag-menu-title">{{country.CountryCode.toUpperCase() + ' | ' +
                        selectedLanguageCode?.toUpperCase()}}</span>
                        <!-- <mat-icon>keyboard_arrow_down</mat-icon> -->
                      </button>
                      <mat-menu #langMenu="matMenu" [overlapTrigger]="false" xPosition="before"
                        class="app-dropdown">
                      @for (country of allowedCountries; track country) {
                        <span>
                          @for (lng of country.CountryLanguages; track lng) {
                            <button mat-menu-item (click)="updatecountry(country, lng.LanguageCode)"
                              >
                              <img [src]="'https://directscalestring.directscale.com/flags/4x3/'+country.CountryCode+'.svg'"
                                width="18"> {{country.CountryName}} | {{lng.LanguageName}}
                              </button>
                            }
                          </span>
                        }
                      </mat-menu>
                    </div>
                  }
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="fx-col fx-flex-100-in-col">
                <div class="p-t-b-7 fx-flex-100-in-col">
                  <span class="color-f-s-15" translate="unifiedapplication_you_purchasing_as"></span>
                </div>
                <div class="fx-flex-100-in-col">
                  <app-customer-type-carousel [customerTypes]="configService.commonSettings.CustomerTypes"
                    [typeSelected]="typeSelected">
                </app-customer-type-carousel>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
        <br>
        </div>
        <div>
          <mat-accordion multi hideToggle>
            <!--personal information section-->
            <mat-expansion-panel class="fx-row-in-expansion-panel" (opened)="panelDisplay = true ;isPanelOpen= true"
              (closed)="panelDisplay = false ;isPanelOpen = false" [expanded]="true">
              <mat-expansion-panel-header class="fx-row-in-expansion-header">
                <ng-container>
                  <div class="fx-row fx-flex-99">
                    <mat-icon [ngClass]="{'is-clicked' : true, 'mat-icon-collapsed' : true}"
                      class="md-default-theme md-toggle-icon pull-left material-icons c-gray"
                      role="img">
                      info
                    </mat-icon>

                    <h4 class="color-f-s-15" translate="Personal_info"></h4>
                  </div>
                </ng-container>
                <ng-container>
                  <div class="fx-row fx-flex-1">
                    <div class="fx-flex-95" (click)="$event.stopPropagation();">
                    </div>
                    <div class="editIcon fx-row fx-main-end fx-cross-stretch fx-flex-5">
                      <mat-icon class="c-gray">keyboard_arrow_down</mat-icon>
                    </div>
                  </div>
                </ng-container>

              </mat-expansion-panel-header>
              <div class="fx-col fx-flex-100">
                <div class="fx-row xs-fx-col fx-main-between fx-cross-stretch fx-flex-100-in-col">
                  <div class="fx-row xs-fx-flex-100-in-col print-fx-flex-49 gt-xs-fx-flex-49">
                    <mat-form-field class="ds-validate fx-flex" appearance="outline">
                      <mat-label translate="unified_shipto_first_name"></mat-label>
                      <input name="firstName" matInput [(ngModel)]="enrollmentForm.FirstName"
                        inputmobilespacendash="true" noempty="true" validname="true"
                        checkOutSection="true" validate autofocus id="firstName">
                    </mat-form-field>
                  </div>
                  <div class="fx-row xs-fx-flex-100-in-col print-fx-flex-49 gt-xs-fx-flex-49">
                    <mat-form-field class="ds-validate fx-flex" appearance="outline">
                      <mat-label translate="unified_shipto_last_name"></mat-label>
                      <input name="lastName" matInput [(ngModel)]="enrollmentForm.LastName"
                        inputmobilespacendash="true" noempty="true" validname="true"
                        checkOutSection="true" validate id="lastName">
                    </mat-form-field>
                  </div>
                </div>
                <div class="fx-row xs-fx-col fx-main-between fx-cross-stretch fx-flex-100-in-col">

                  <div class="xs-fx-flex-100-in-col print-fx-flex-30 gt-xs-fx-flex-30">
                    <mat-form-field class="ds-validate" appearance="outline">
                      <mat-label translate="unifiedapplication_birthdate"></mat-label>
                      <mat-select [(ngModel)]="enrollmentForm.BirthDay"
                        [(value)]="enrollmentForm.BirthDay" validate checkOutSection="true"
                        validate-select="true"
                        [attr.agelimit]="enrollmentForm.BirthMonth +'/'+ enrollmentForm.BirthDay +'/'+ enrollmentForm.BirthYear"
                        id="day" (selectionChange)="doberror($event)">
                        @for (day of days; track $index) {
                          <mat-option [value]="day">
                            {{day}}
                          </mat-option>
                        }
                      </mat-select>

                    </mat-form-field>
                  </div>
                  <div class="xs-fx-flex-100-in-col print-fx-flex-30 gt-xs-fx-flex-30">
                    <mat-form-field class="ds-validate" appearance="outline">
                      <mat-label translate="unified_birth_month"></mat-label>
                      <mat-select [(ngModel)]="enrollmentForm.BirthMonth"
                        [(value)]="enrollmentForm.BirthMonth"
                        (selectionChange)="utilityService.birthDays();" validate
                        checkOutSection="true" validate-select="true"
                        [attr.agelimit]="enrollmentForm.BirthMonth +'/'+ enrollmentForm.BirthDay +'/'+ enrollmentForm.BirthYear"
                        id="month" (selectionChange)="doberror($event)">
                        @for (month of months; track $index) {
                          <mat-option [value]="month.value">
                            {{month.text}}
                          </mat-option>
                        }
                      </mat-select>

                    </mat-form-field>
                  </div>
                  <div class="xs-fx-flex-100-in-col print-fx-flex-30 gt-xs-fx-flex-30">
                    <mat-form-field class="ds-validate" appearance="outline">
                      <mat-label translate="unified_birth_year"></mat-label>
                      <mat-select [(ngModel)]="enrollmentForm.BirthYear"
                        [(value)]="enrollmentForm.BirthYear"
                        (selectionChange)="utilityService.birthDays();" validate
                        checkOutSection="true" validate-select="true"
                        [attr.agelimit]="enrollmentForm.BirthMonth +'/'+ enrollmentForm.BirthDay +'/'+ enrollmentForm.BirthYear"
                        id="year" (selectionChange)="doberror($event)">
                        @for (year of years; track $index) {
                          <mat-option [value]="year.value">
                            {{year.text}}
                          </mat-option>
                        }
                      </mat-select>

                    </mat-form-field>
                  </div>
                </div>
                @if (ageError) {
                  <div class="custom-errors fx-flex-100-in-col">
                    <p> According to your date of birth, you are under the minimum age requirement of
                    18. You must be 18 or above to represent Think Energy as an Energy Advisor.</p>
                  </div>
                }
              </div>
            </mat-expansion-panel>
            <br>
              <!--personal infor section ends-->
              <!--billing address starts-->
              <mat-expansion-panel class="fx-row-in-expansion-panel" (opened)="panelDisplay = true ;isPanelOpen= true"
                (closed)="panelDisplay = false ;isPanelOpen = false" [expanded]="true">
                <mat-expansion-panel-header class="fx-row-in-expansion-header">
                  <ng-container>
                    <div class="fx-row fx-flex-99">
                      <mat-icon [ngClass]="{'is-clicked' : true, 'mat-icon-collapsed' : true}"
                        class="md-default-theme md-toggle-icon pull-left material-icons c-gray"
                        role="img">
                        location_on
                      </mat-icon>

                      <h4 class="color-f-s-15" translate="Billing_info"></h4>
                    </div>
                  </ng-container>
                  <ng-container>
                    <div class="fx-row fx-flex-1">
                      <div class="fx-flex-95" (click)="$event.stopPropagation();">
                      </div>
                      <div class="editIcon fx-row fx-main-end fx-cross-stretch fx-flex-5">
                        <mat-icon class="c-gray">keyboard_arrow_down</mat-icon>
                      </div>
                    </div>
                  </ng-container>

                </mat-expansion-panel-header>
                <div class="fx-col fx-flex-100">
                  <div class="fx-row fx-flex-100-in-col">
                    <mat-form-field class="ds-validate fx-flex" appearance="outline">
                      <mat-label translate="Billing_info_street1"></mat-label>
                      <input name="billing_streetAddress" matInput
                        [(ngModel)]="enrollmentForm.ApplicantAddress.Street1" checkOutSection="true"
                        validate noempty="true" validate-maxlength="25" maxlength="25"
                        (focusout)="copyToShipping()">

                    </mat-form-field>
                  </div>
                  <div class="fx-row fx-flex-100-in-col">
                    <mat-form-field class="ds-validate fx-flex" appearance="outline">
                      <mat-label translate="Billing_info_street2"></mat-label>
                      <input name="apartment" matInput
                        [(ngModel)]="enrollmentForm.ApplicantAddress.Street2"
                        (focusout)="copyToShipping()">
                    </mat-form-field>
                  </div>

                  <div class="fx-row xs-fx-col fx-main-between fx-cross-stretch fx-flex-100-in-col">
                    <div class="fx-row xs-fx-flex-100-in-col print-fx-flex-30 gt-xs-fx-flex-30">
                      <mat-form-field class="ds-validate fx-flex" appearance="outline">
                        <mat-label translate="Billing_info_city"></mat-label>
                        <input name="city" matInput [(ngModel)]="enrollmentForm.ApplicantAddress.City"
                          inputmobilespacendash="true" noempty="true" validname="true" (focusout)="copyToShipping()"
                          checkOutSection="true" validate>

                      </mat-form-field>
                    </div>
                    <div class="fx-row xs-fx-flex-100-in-col print-fx-flex-30 gt-xs-fx-flex-30">
                      <mat-form-field class="ds-validate fx-flex" appearance="outline">
                        <mat-label translate="Billing_info_State"></mat-label>
                        <mat-select [(ngModel)]="enrollmentForm.ApplicantAddress.Region"
                          (selectionChange)="getStateName(true);copyToShipping()" validate noempty="true"
                          validate-select checkOutSection="true" id="regions">
                          @for (state of states; track state) {
                            <mat-option [value]="state.StateCode">
                              {{state.StateName}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="fx-row xs-fx-flex-100-in-col print-fx-flex-30 gt-xs-fx-flex-30">
                      <mat-form-field class="ds-validate fx-flex" appearance="outline">
                        <mat-label [translate]="'Billing_info_zip'">Zip</mat-label>
                        <input name="zip" matInput
                          [(ngModel)]="enrollmentForm.ApplicantAddress.PostalCode" validate
                          checkOutSection="true" noempty="true" custommsg="invalid_zip"
                          (focusout)="regexValidateBillingZip(selectedCountry,enrollmentForm.ApplicantAddress.PostalCode);checkstate(enrollmentForm.ApplicantAddress.Region,'billing');copyToShipping()" />
                        @if (showErrorBilling) {
                          <div>
                            <small class="help-block has-errors">Invalid Zip code</small>
                          </div>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="fx-row fx-flex-100-in-col">
                    <mat-form-field class="ds-validate fx-flex" appearance="outline">
                      <mat-label translate="country_code"></mat-label>
                      <input matInput [(ngModel)]="country.CountryName" [disabled]="true">
                    </mat-form-field>
                  </div>
                </div>
                <br>
                </mat-expansion-panel>
                <br>
                  <!--billing address ends-->
                  <!--shipping starts-->
                  <mat-expansion-panel class="fx-row-in-expansion-panel" (opened)="panelDisplay = true ;isPanelOpen= true"
                    (closed)="panelDisplay = false ;isPanelOpen = false" [expanded]="true">
                    <mat-expansion-panel-header class="fx-row-in-expansion-header">
                      <ng-container>
                        <div class="fx-row fx-flex-99">
                          <mat-icon [ngClass]="{'is-clicked' : true, 'mat-icon-collapsed' : true}"
                            class="md-default-theme md-toggle-icon pull-left material-icons c-gray"
                            role="img">
                            local_shipping
                          </mat-icon>
                          <h4 class="color-f-s-15" translate="unifiedapplication_mailing_address"></h4>
                        </div>
                      </ng-container>
                      <ng-container>
                        <div class="fx-row fx-flex-1">
                          <div class="fx-flex-95" (click)="$event.stopPropagation();">
                          </div>
                          <div class="editIcon fx-row fx-main-end fx-cross-stretch fx-flex-5">
                            <mat-icon class="c-gray">keyboard_arrow_down</mat-icon>
                          </div>
                        </div>
                      </ng-container>
                    </mat-expansion-panel-header>
                    <div class="fx-col fx-flex-100">
                      <div class="checkbox fx-flex-100-in-col">
                        <mat-checkbox [(ngModel)]="enrollmentForm.billingAddressSame"
                          (change)="checkboxBilling($event)" name="sameBillingCheck"
                          [checked]="enrollmentForm.billingAddressSame" validate style="margin-bottom: 10px;">
                          <p class="color2-f-s-12"
                            translate="unifiedapplication_same_billing_address_checkbox">
                          </p>
                        </mat-checkbox>
                      </div>
                      <p class="f-s-12-m-0" [translate]="'no_po_box_shipping_address'">PO Box address(es) are not allowed as the Shipping Address.</p>
                      <div class="fx-row fx-flex-100-in-col">
                        <mat-form-field class="ds-validate fx-flex" appearance="outline">
                          <mat-label translate="unified_shipto_address"></mat-label>
                          <input name="streetAddress" matInput (focusout)="checkaddressPO(enrollmentForm.ShippingAddress.Street1)" (input)="checkaddressPO(enrollmentForm.ShippingAddress.Street1,1)"
                            [(ngModel)]="enrollmentForm.ShippingAddress.Street1" checkOutSection="true"
                            validate noempty="true" validate-maxlength="25" maxlength="25"
                            id="notcheckedstreet1" class="shippingAddress">
                          @if (ShippingError1) {
                            <div>
                              <small class="help-block has-errors">PO Box addresses are not allowed. Please use physical street address.</small>
                            </div>
                          }
                        </mat-form-field>
                      </div>
                      <div class="fx-row fx-flex-100-in-col">
                        <mat-form-field class="ds-validate fx-flex" appearance="outline">
                          <mat-label translate="unified_shipto_address2"></mat-label>
                          <input name="apartment" matInput validate (focusout)="checkaddressPO(enrollmentForm.ShippingAddress.Street2)" (input)="checkaddressPO(enrollmentForm.ShippingAddress.Street2,2)"
                            [(ngModel)]="enrollmentForm.ShippingAddress.Street2" id="notcheckedstreet2" class="shippingAddress">
                          @if (ShippingError2) {
                            <div>
                              <small class="help-block has-errors">PO Box addresses are not allowed. Please use physical street address.</small>
                            </div>
                          }
                        </mat-form-field>
                      </div>
                      <div class="fx-row xs-fx-col fx-main-between fx-cross-stretch fx-flex-100-in-col">
                        <div class="fx-row xs-fx-flex-100-in-col print-fx-flex-30 gt-xs-fx-flex-30">
                          <mat-form-field class="ds-validate fx-flex" appearance="outline">
                            <mat-label translate="unified_shipto_city"></mat-label>
                            <input name="city" class="shippingAddress" matInput [(ngModel)]="enrollmentForm.ShippingAddress.City"
                              inputmobilespacendash="true" noempty="true" validname="true"
                              checkOutSection="true" validate>
                          </mat-form-field>
                        </div>
                        <div class="fx-row xs-fx-flex-100-in-col print-fx-flex-30 gt-xs-fx-flex-30">
                          <mat-form-field class="ds-validate fx-flex" appearance="outline">
                            <mat-label translate="unified_shipto_state"></mat-label>
                            <mat-select class="shippingAddress" [(ngModel)]="enrollmentForm.ShippingAddress.Region"
                              (selectionChange)="getStateName(true);getpaymentMethod(enrollmentForm.ShippingAddress.Region)" validate noempty="true"
                              validate-select checkOutSection="true" id="regionsshipping" [disabled]="enrollmentForm.billingAddressSame">
                              @for (state of states; track state) {
                                <mat-option [value]="state.StateCode">
                                  {{state.StateName}}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="fx-row xs-fx-flex-100-in-col print-fx-flex-30 gt-xs-fx-flex-30">
                          <mat-form-field class="ds-validate fx-flex" appearance="outline">
                            <mat-label [translate]="'unified_shipto_zipcode'">Zip</mat-label>
                            <input name="zip" matInput validate noempty="true" [attr.regexcountry]
                              [(ngModel)]="enrollmentForm.ShippingAddress.PostalCode" validate
                              checkOutSection="true" custommsg="INVALID ZIP" class="shippingAddress"
                              (focusout)="regexValidateShippingZip(selectedCountry,enrollmentForm.ShippingAddress.PostalCode);checkstate(enrollmentForm.ShippingAddress.Region,'shipping')">
                            @if (showErrorShipping) {
                              <div>
                                <small class="help-block has-errors">Invalid Zip code</small>
                              </div>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="fx-row fx-flex-100-in-col">
                        <mat-form-field class="ds-validate fx-flex" appearance="outline">
                          <mat-label translate="country_code"></mat-label>
                          <input matInput [(ngModel)]="country.CountryName" [disabled]="true">
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                  <br>
                    <!--shipping ends-->
                    <!--email section starts-->
                    <mat-expansion-panel class="fx-row-in-expansion-panel" (opened)="panelDisplay = true ;isPanelOpen= true"
                      (closed)="panelDisplay = false ;isPanelOpen = false" [expanded]="true">
                      <mat-expansion-panel-header class="fx-row-in-expansion-header">
                        <ng-container>
                          <div class="fx-row fx-flex-99">
                            <mat-icon [ngClass]="{'is-clicked' : true, 'mat-icon-collapsed' : true}"
                              class="md-default-theme md-toggle-icon pull-left material-icons c-gray"
                              role="img">
                              alternate_email
                            </mat-icon>

                            <h4 class="color-f-s-15" translate="email_address"></h4>
                          </div>
                        </ng-container>
                        <ng-container>
                          <div class="fx-row fx-flex-1">
                            <div class="fx-flex-95" (click)="$event.stopPropagation();">
                            </div>
                            <div class="editIcon fx-row fx-main-end fx-cross-stretch fx-flex-5">
                              <mat-icon class="c-gray">keyboard_arrow_down</mat-icon>
                            </div>
                          </div>
                        </ng-container>
                      </mat-expansion-panel-header>
                      <div class="fx-col fx-flex-100">
                        <div class="fx-row fx-flex-100-in-col">
                          <mat-form-field class="ds-validate fx-flex" appearance="outline">
                            <mat-label translate="unifiedapplication_email_Add"></mat-label>
                            <input name="email" matInput [(ngModel)]="emails" email="true" noempty="true"
                              (focusout)="enrollmentEmailVerification(emails);" validate nospaceallow="true"
                              checkOutSection="true" id="email">
                          </mat-form-field>
                        </div>
                        @if (emailAlreadyexist) {
                          <div>
                            <small class="help-block">The email address you provided is already in use by an
                              existing Energy Advisor account. Please provide an email address not currently
                            in use by another Energy Advisor</small>
                          </div>
                        }
                        <div class="fx-flex-80-in-col">
                          <p style="font-size: 10px;"
                            [translate]="'email_msg_optin'">
                            (To help stay in touch with the growth of your business
                            through email notifications of customer enrollments, downline Energy Advisor
                            enrollments and rank advancements, as well as other messages, we strongly suggest
                            you opt-in to email messaging. You will have the option of changing these settings
                          within your Think+ Portal, at a later time, if you so desire.)</p>
                        </div>
                        <div class="fx-row fx-flex-100-in-col">
                          <div class="ds-validate fx-flex-4 xs-fx-flex-8">
                            <mat-checkbox [(ngModel)]="enrollmentForm.subscribeToCorporateEmails"
                              mat-checkbox-checked>
                            </mat-checkbox>
                          </div>
                          <div class="fx-flex-96 xs-fx-flex-92">
                            <p class="color2-f-s-12"
                              translate="unifiedapplication_yes_receive_emails_about_business">
                            </p>
                          </div>

                        </div>
                      </div>
                    </mat-expansion-panel>
                    <br>
                      <!--email section ends-->
                      <!--phone section starts-->
                      <mat-expansion-panel class="fx-row-in-expansion-panel" (opened)="panelDisplay = true ;isPanelOpen= true"
                        (closed)="panelDisplay = false ;isPanelOpen = false" [expanded]="true">
                        <mat-expansion-panel-header class="fx-row-in-expansion-header">
                          <ng-container>
                            <div class="fx-row fx-flex-99">
                              <mat-icon [ngClass]="{'is-clicked' : true, 'mat-icon-collapsed' : true}"
                                class="md-default-theme md-toggle-icon pull-left material-icons c-gray"
                                role="img">
                                mobile_friendly
                              </mat-icon>

                              <h4 class="color-f-s-15" translate="phone_contact"></h4>
                            </div>
                          </ng-container>
                          <ng-container>
                            <div class="fx-row fx-flex-1">
                              <div class="fx-flex-95" (click)="$event.stopPropagation();">
                              </div>
                              <div class="editIcon fx-row fx-main-end fx-cross-stretch fx-flex-5">
                                <mat-icon class="c-gray">keyboard_arrow_down</mat-icon>
                              </div>
                            </div>
                          </ng-container>
                        </mat-expansion-panel-header>
                        <div class="fx-col fx-flex-100" id="preventIphoneselect">
                          <div class="fx-row fx-flex-100-in-col">
                            <mat-form-field class="ds-validate fx-flex" appearance="outline">
                              <mat-label translate="unified_primary_phone"></mat-label>
                              <input name="phoneNumber" id="myInput" validate matInput
                                [(ngModel)]="enrollmentForm.PrimaryPhone" (contextmenu)="preventmenu($event)" phoneno="true" inputonlynumber="true"
                                checkOutSection="true" maxlength="20" minlength="10" class="billingFormInput">
                            </mat-form-field>
                          </div>
                          <div class="fx-row fx-flex-100-in-col">
                            <mat-form-field class="ds-validate fx-flex" appearance="outline">
                              <mat-label translate="unified_mobile_phone"></mat-label>
                              <input name="phoneNumber" validate id="textnumber" matInput
                                [(ngModel)]="enrollmentForm.TextNumber" phoneno="true" inputonlynumber="true"
                                checkOutSection="true"
                                [attr.noempty]="enrollmentForm.subscribeToCorporateTexts?'true':null"
                                minlength="10" maxlength="20" class="billingFormInput"
                                (change)="validateTextNumber($event)"
                                class="TextNumberInput">
                            </mat-form-field>
                          </div>

                          <div class="fx-flex-80-in-col">
                            <p style="font-size: 10px;"
                              [translate]="'sms_msg_optin'">
                              (For real-time notifications to your phone, we strongly
                              suggest you opt-in to SMS / MMS messaging. By receiving SMS /MMS messages, you will
                              be able to know of customer enrollments, downline Energy Advisor enrollments and
                              rank advancements, as well as other messages. You will have the option of changing
                            these settings within your Think+ Portal, at a later time, if you so desire.)</p>
                          </div>
                          <div class="fx-row fx-flex-100-in-col">
                            <div class="ds-validate fx-flex-4 xs-fx-flex-8">
                                    <mat-checkbox id="textnum" custommsg="In order to Opt-In to SMS / MMS messaging, you must
                                    provide a valid Text Phone Number. Please enter one now."
                                [attr.checkbox-validate]="enrollmentForm.subscribeToCorporateTexts?'true':null"
                                [(ngModel)]="enrollmentForm.subscribeToCorporateTexts"
                                (change)="textNumberCheckboxStateChanged($event)">
                              </mat-checkbox>
                            </div>
                            <div class="fx-flex-96 xs-fx-flex-92">
                              <p class="color2-f-s-12"
                                translate="unifiedapplication_yes_receive_texts_about_business">
                              </p>
                            </div>
                          </div>
                          @if (((enrollmentForm.subscribeToCorporateTexts)&&(textnumberempty))) {
                            <div>
                              <small class="help-block">In order to Opt-In to SMS / MMS messaging, you must
                              provide a valid Text Phone Number. Please enter one now.</small>
                            </div>
                          }
                        </div>
                      </mat-expansion-panel>
                      <br>
                        <!--phone section ends-->
                        <!--username section start-->
                        <mat-expansion-panel class="fx-row-in-expansion-panel" (opened)="panelDisplay = true ;isPanelOpen= true"
                          (closed)="panelDisplay = false ;isPanelOpen = false" [expanded]="true">
                          <mat-expansion-panel-header class="fx-row-in-expansion-header">
                            <ng-container>
                              <div class="fx-row fx-flex-99">
                                <mat-icon [ngClass]="{'is-clicked' : true, 'mat-icon-collapsed' : true}"
                                  class="md-default-theme md-toggle-icon pull-left material-icons c-gray"
                                  role="img">
                                  account_circle
                                </mat-icon>
                                <h4 class="color-f-s-15" translate="unifiedapplication_username"></h4>
                              </div>
                            </ng-container>
                            <ng-container>
                              <div class="fx-row fx-flex-1">
                                <div class="fx-flex-95" (click)="$event.stopPropagation();">
                                </div>
                                <div class="editIcon fx-row fx-main-end fx-cross-stretch fx-flex-5">
                                  <mat-icon class="c-gray">keyboard_arrow_down</mat-icon>
                                </div>
                              </div>
                            </ng-container>
                          </mat-expansion-panel-header>
                          <div class="fx-col fx-flex-100">
                            <div class="fx-row fx-flex-100-in-col">
                              <mat-form-field class="ds-validate fx-flex" appearance="outline">
                                <mat-label translate="unifiedapplication_choose_username"></mat-label>
                                <input name="userName" matInput [(ngModel)]="enrollmentForm.Username"
                                  nospaceallow="true" validate NOunderscore="true" validname="true"
                                  (focusout)="verifyUsername(enrollmentForm.Username);"
                                  (copy)="$event.preventDefault()" (paste)="$event.preventDefault()">
                                @if (showErrorUsername) {
                                  <div>
                                    <small class="help-block has-errors">{{usernameErrorMessage}}</small>
                                  </div>
                                }
                              </mat-form-field>
                            </div>
                            <div class="fx-flex-80-in-col">
                              <p style="font-size: 10px;"
                                [translate]="'submit_requested_username'">
                                (Please submit your requested Username. Your username
                                will be the unique ending to your ThinkEnergy.com website as well as your login
                                username for the Think+ Portal where you can manage and track your efforts as an
                                Energy Advisor. The Username must be unique and not currently in use by any
                                existing Energy Advisors. If you do not wish to select a username at this
                                moment, you can continue on and select a username later through your Think+
                                Portal. In the meantime, a unique Energy Advisor ID number will be your
                                default username. The username must consist of only uppercase letters,
                              lowercase letters and numbers. No special characters are permitted)</p>
                            </div>
                            <div  class="fx-col fx-flex-100-in-col">
                              <div class="fx-row fx-flex-100-in-col">
                                <mat-form-field class="ds-validate fx-flex" appearance="outline">
                                  <mat-label translate="unifiedapplication_choose_password"></mat-label>
                                  <input name="password" matInput type="password" [(ngModel)]="enrollmentForm.Password"
                                    nospaceallow="true" validate
                                    (focusout)="verifyPassword(enrollmentForm.Password, enrollmentForm.confirmPassword);"
                                    (copy)="$event.preventDefault()" (paste)="$event.preventDefault()">
                                  @if (showErrorPassword) {
                                    <div>
                                      <small class="help-block has-errors">{{passwordErrorMessage}}</small>
                                    </div>
                                  }
                                </mat-form-field>
                              </div>
                              <div class="fx-row fx-flex-100-in-col">
                                <mat-form-field class="ds-validate fx-flex" appearance="outline">
                                  <mat-label translate="unifiedapplication_verify_password"></mat-label>
                                  <input name="confirmPassword" matInput type="password" [(ngModel)]="enrollmentForm.confirmPassword"
                                    nospaceallow="true" validate
                                    (focusout)="verifyPassword(enrollmentForm.Password, enrollmentForm.confirmPassword);"
                                    (copy)="$event.preventDefault()" (paste)="$event.preventDefault()">
                                  @if (showErrorPassword) {
                                    <div>
                                      <small class="help-block has-errors">{{passwordErrorMessage}}</small>
                                    </div>
                                  }

                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                        </mat-expansion-panel>
                        <br>
                          <!--username section ends-->
                          <!--checkbox section start-->
                          <mat-expansion-panel class="fx-row-in-expansion-panel" (opened)="panelDisplay= true ;isPanelOpen= true"
                            (closed)="panelDisplay = false ;isPanelOpen = false" [expanded]="true">
                            <mat-expansion-panel-header class="fx-row-in-expansion-header">
                              <ng-container>
                                <div class="fx-row fx-flex-99">
                                  <mat-icon [ngClass]="{'is-clicked' : true, 'mat-icon-collapsed' : true}"
                                    class="md-default-theme md-toggle-icon pull-left material-icons c-gray"
                                    role="img">
                                    check_circle_outline
                                  </mat-icon>
                                  <h4 class="color-f-s-15" translate="unifiedapplication_step_4_Checkbox_section">
                                  </h4>
                                </div>
                              </ng-container>
                              <ng-container>
                                <div class="fx-row fx-flex-1">

                                  <div class="fx-row fx-flex-100">
                                    <div class="fx-flex-95">
                                    </div>
                                    <div class="editIcon fx-row fx-main-end fx-cross-stretch fx-flex-5">
                                      <mat-icon class="c-gray">keyboard_arrow_down</mat-icon>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                            </mat-expansion-panel-header>
                            <div class="fx-col fx-flex-100">
                              <div class="fx-row fx-flex-100-in-col">
                                <div class="mat-form-field ds-validate fx-flex-100">
                                    <mat-checkbox [(ngModel)]="agreetoconditions" validate custommsg="Before completing your enrollment as an Energy Advisor it
                                    is required you review and acknowledge you're understanding of the Think+
                                    Representative Agreement, Policies & Procedures and Compensation Plan. Please
                                    confirm you have reviewed these documents to continue the enrollment
                                    process." (change)="checkboxFunction($event)" checkbox-validate="true">
                                    <p class="color-f-s-13"
                                      [translate]="'acknowledge_receipt_advisor_agreements'">
                                      Please acknowledge the receipt of the Think+ Energy Advisor Agreements. All
                                      Agreement documents are listed in the “Policies” block (below the Order
                                      Summary).
                                    </p>
                                  </mat-checkbox>
                                </div>
                              </div>
                              <br>
                                <div>
                                  <p class="f-s-12"
                                    [translate]="'acknowledge_receipt_advisor_agreements_note'">
                                    Note: the enrollment fee is a one-time fee, with an annual renewal fee on your
                                  enrollment anniversary.</p>
                                </div>
                              </div>
                            </mat-expansion-panel>
                            <br>

                              <!-- checkbox for criminal history -->
                              <mat-expansion-panel class="fx-row-in-expansion-panel" (opened)="panelDisplay= true ;isPanelOpen= true"
                                (closed)="panelDisplay = false ;isPanelOpen = false" [expanded]="true">
                                <mat-expansion-panel-header class="fx-row-in-expansion-header">
                                  <ng-container>
                                    <div class="fx-row fx-flex-99">
                                      <mat-icon [ngClass]="{'is-clicked' : true, 'mat-icon-collapsed' : true}"
                                        class="md-default-theme md-toggle-icon pull-left material-icons c-gray"
                                        role="img">
                                        check_circle_outline
                                      </mat-icon>
                                      <h4 class="color-f-s-15" translate="unifiedapplication_step_5_Checkbox_section">
                                      </h4>
                                    </div>
                                  </ng-container>
                                  <ng-container>
                                    <div class="fx-row fx-flex-1">

                                      <div class="fx-row fx-flex-100">
                                        <div class="fx-flex-95">
                                        </div>
                                        <div class="editIcon fx-row fx-main-end fx-cross-stretch fx-flex-5">
                                          <mat-icon class="c-gray">keyboard_arrow_down</mat-icon>
                                        </div>
                                      </div>
                                    </div>
                                  </ng-container>
                                </mat-expansion-panel-header>
                                <div class="fx-col fx-flex-100">
                                  <div class="fx-flex-80-in-col">
                                    <p style="font-size: 13px;">{{"energywell_criminalhistory_note" | translate}}</p>
                                  </div>
                                  <div class="fx-row fx-flex-100-in-col">
                                    <div class="mat-form-field ds-validate fx-flex-100">
                                      <mat-checkbox [(ngModel)]="criminalCheck" validate
                                        id="criminalCheck" checkbox-validate="true"
                                        custommsg="In order for you to complete your enrollment as an Energy
                                        Advisor you are required to submit to a Criminal Background Check.">
                                        <p class="color-f-s-13">{{"energywell_agree_to_criminalhistory" | translate}}
                                        </p>
                                      </mat-checkbox>
                                    </div>
                                  </div>
                                </div>
                              </mat-expansion-panel>
                              <br>
                                <!--checkbox section ends-->
                                <!--payment section start-->
                                <mat-expansion-panel class="fx-row-in-expansion-panel" (opened)="panelDisplay= true; isPanelOpen= true"
                                  (closed)="panelDisplay = false ;isPanelOpen = false" [expanded]="true">
                                  <mat-expansion-panel-header class="fx-row-in-expansion-header">
                                    <ng-container>
                                      <div class="fx-row fx-flex-80">
                                        <mat-icon [ngClass]="{'is-clicked' : true, 'mat-icon-collapsed' : true}"
                                          class="md-default-theme md-toggle-icon pull-left material-icons c-gray"
                                          role="img">
                                          credit_card
                                        </mat-icon>
                                        <h4 class="color-f-s-15" [translate]="'unifiedapplication_payment_method'">Payment
                                          Method
                                        </h4>
                                      </div>
                                    </ng-container>
                                    <ng-container>
                                      <div class="fx-row fx-flex-100">
                                        <div class="fx-flex-95">
                                        </div>
                                        <div class="editIcon fx-row fx-main-end fx-cross-stretch fx-flex-5">
                                          <mat-icon class="c-gray">keyboard_arrow_down</mat-icon>
                                        </div>
                                      </div>
                                    </ng-container>
                                  </mat-expansion-panel-header>
                                  <div class="fx-col fx-flex-100">
                                    <div class="fx-row fx-flex-100-in-col">
                                      <mat-form-field class="fx-flex" appearance="outline">
                                        @if (userService.paymentMethods.length > 0 && !userService.isPaymentChanged) {
                                          <mat-label
                                            >
                                            <span [textContent]="userService.paymentMethods[0].CardType"></span>
                                            <span [textContent]="userService.paymentMethods[0].Last4"></span>
                                          </mat-label>
                                        }
                                        @if (userService.paymentMethods.length == 0) {
                                          <mat-label
                                          translate="unified_add_payment_method"></mat-label>
                                        }
                                        <mat-select>
                                          <mat-select-trigger>
                                            @if (userService.paymentMethods.length > 0) {
                                              <span>
                                                {{userService.paymentMethods[0].CardType}} {{ ' ' }}
                                              {{userService.paymentMethods[0].Last4}} </span>
                                            }
                                            @if (userService.paymentMethods.length == 0) {
                                              <span
                                              [textContent]="'unified_add_payment_method' | translate"></span>
                                            }
                                          </mat-select-trigger>
                                          <mat-option [textContent]="'unified_add_payment_method' | translate">
                                          </mat-option>
                                          @if (paymentService.PaymentTypeResponse['AllowedMethods']) {
                                            @for (addpayments of paymentService.PaymentTypeResponse['AllowedMethods']; track addpayments) {
                                              <mat-option
                                                value="Credit Card" validate trigger-check='true' (success)="addSavePayment(addpayments);"
                                                class="c-color1" [attr.merchant_id]="addpayments.MerchantID"
                                                [innerHTML]="addpayments.DisplayName | paymentTranslate:addpayments.DisplayName"
                                              translate></mat-option>
                                            }
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    </div>
                                    @if (userService.paymentMethods.length >0 && (paymentService.SelectedPaymentTypes.CanSavePayments == false || paymentService.SelectedPaymentTypes.CanSavePayments == 'false')) {
                                      <div class="ds-row__item clearfix m-l-0"
                                        >
                                        @if (!userService.paymentMethods[0]?.Redirect) {
                                          <span class="ds-row__item clearfix"
                                          [innerHTML]="('order_pending') | translate" translate></span>
                                        }
                                        @if (userService.paymentMethods[0]?.Redirect) {
                                          <span class="ds-row__item clearfix"
                                          [innerHTML]="('order_needs_redirect') | translate" translate></span>
                                        }
                                        <span [innerHTML]="('click_here_payment_inst') | translate">
                                        </span>
                                      </div>
                                    }
                                    @if (userService.paymentMethods.length >0) {
                                      <div class="ds-row__item m-t-10">
                                        <div class="m-b-10">
                                          <span class="f-s-12" [textContent]="userService.paymentMethods[0].CardType"></span>
                                          @if (userService.paymentMethods[0].Last4) {
                                            <span class="f-s-12"
                                            translate="unifiedapplication_card_ending_in"></span>
                                          }
                                          <span class="f-s-12" [textContent]="userService.paymentMethods[0].Last4"></span>
                                          <br>
                                            @if (userService.paymentMethods[0].ExpireMonth!==0 && userService.paymentMethods[0].ExpireYear!==0) {
                                              <span
                                                >
                                                <span>{{'expires'|translate}}</span>&nbsp; <span
                                              [textContent]="userService.paymentMethods[0].ExpireMonth"></span> /
                                              <span [textContent]="userService.paymentMethods[0].ExpireYear"></span>
                                            </span>
                                          }
                                        </div>
                                      </div>
                                    }

                                    @if (false) {
                                      <div class="m-t-10 fx-flex-100-in-col">
                                        <mat-radio-group #radioGroup="matRadioGroup"
                                          [(ngModel)]="enrollmentForm.billingAddressSame" aria-label="Select an option"
                                          class="fx-col">
                                          <mat-label class="color-f-s-13"
                                            translate="unifiedapplication_what_shipping_address">
                                          </mat-label>
                                          <mat-radio-button class="m-b-10 color2-f-s-12" [value]="true">
                                          {{"unifiedapplication_use_same_address" | translate}}</mat-radio-button>
                                          <mat-radio-button class="m-b-10 color2-f-s-12" [value]="false">
                                            {{"unifiedapplication_different_shipping_adddress" | translate}}
                                          </mat-radio-button>
                                        </mat-radio-group>
                                      </div>
                                    }
                                    <div class="fx-flex-100-in-col">
                                      @if (enrollmentForm.billingAddressSame) {
                                        <form>
                                        </form>
                                      }
                                    </div>
                                    @if (false) {
                                      <div class="fx-flex-100-in-col">
                                        <mat-radio-group aria-label="Select an option" class="fx-col"
                                          [(ngModel)]="userService.selectedShippingMethod">
                                          <mat-label class="color-f-s-13" translate="unifiedapplication_choosing_a_shipping">
                                          </mat-label>
                                          @for (shipmethod of userService.shippingMethods; track shipmethod) {
                                            <mat-radio-button class="m-b-10 color2-f-s-12" [value]="shipmethod.ShipMethodId"
                                              (click)="getShipName()">
                                              <div class="fx-col">
                                                <div>
                                                  <span [textContent]="shipmethod.Description"></span> &nbsp;&nbsp;
                                                  <span
                                                  [textContent]="shipmethod.ShippingAmount | currency:companyService.selectedCurrency.CurrencyCode"></span>
                                                </div>
                                              </div>
                                            </mat-radio-button>
                                          }
                                        </mat-radio-group>
                                      </div>
                                    }
                                    @if (false) {
                                      <div>
                                        <mat-radio-group aria-label="Select an option" class="fx-col"
                                          [(ngModel)]="userService.selectedShippingMethod">
                                          <mat-label class="color-f-s-13" translate="unifiedapplication_choosing_a_shipping">
                                          </mat-label>
                                          @for (shipmethod of userService.shippingMethods; track shipmethod) {
                                            <mat-radio-button class="m-b-10 color2-f-s-12" [value]="shipmethod.ShipMethodId"
                                              (click)="getShipName(shipmethod.ShipMethodId)">
                                              <div class="fx-col">
                                                <div>
                                                  <span [textContent]="shipmethod.Description"></span> &nbsp;&nbsp;
                                                  <span
                                                  [textContent]="shipmethod.ShippingAmount | currency:companyService.selectedCurrency.CurrencyCode"></span>
                                                </div>
                                              </div>
                                            </mat-radio-button>
                                          }
                                        </mat-radio-group>
                                      </div>
                                    }
                                  </div>
                                </mat-expansion-panel>
                                <br>
                                  <!--payment section ends-->
                                </mat-accordion>
                              </div>
                            </div>
                            <!--Side Cart starts here-->
                            <div class="secondContent lt-lg-fx-flex-100-in-col print-fx-flex-100 gt-md-fx-flex-100" id="sideCartBox"
                              [ngClass]="{'full-sideCartBox-height' : isPanelOpen}" (opened)="isPanelOpen= true"
                              (closed)="isPanelOpen = false">
                              <mat-card appearance="outlined">
                                <mat-accordion [togglePosition]="'before'" multi>
                                  <div class="p-t-9 fx-col">
                                    <div class="fx-row fx-flex-100-in-col">
                                      <div class="p-r-25 fx-row fx-main-start fx-cross-stretch fx-flex-7">
                                        <mat-icon matBadge="{{getQuanity()}} " matBadgeOverlap="true" matBadgeSize="small"
                                          class="c-gray">
                                        shopping_cart</mat-icon>
                                      </div>
                                      <div class="fx-col fx-flex-75">
                                        <div>
                                          <span class="orderSummary" translate="unifiedapplication_order_summary"></span>
                                        </div>
                                        <!-- <div>
                                        <span class="itemCount" translate="unifiedapplication_global_total"></span>
                                        <span *ngIf="itemsService.selectedOrderItems.length>0" class="itemCount"
                                        [textContent]="': (' + getOrderQuanity()+ ' items)'"></span>
                                      </div> -->
                                    </div>
                                    <div class="fx-col fx-main-start fx-cross-end fx-flex-20">
                                      @if (itemsService.selectedOrderItems.length>0) {
                                        <div>
                                          <strong
                                          [textContent]="(orderService.calculateOrderResponse.Total) ? (orderService.calculateOrderResponse.Total) : 0 | currency:companyService.selectedCurrency.CurrencyCode"></strong>
                                        </div>
                                      }
                                      <div>
                                        <!-- <span class="itemCount" translate="unifiedapplication_global_pv"></span>
                                        <span class="itemCount" *ngIf="itemsService.selectedOrderItems.length>0">:
                                        {{((orderService?.orderBusinessVolume) || 0)}}</span>
                                        <span class="itemCount" *ngIf="itemsService.selectedOrderItems.length==0">:
                                        {{((orderService?.autoorderBusinessVolume)||0)}}</span> -->
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Section For Pack Items -->
                                  @if (itemsService.selectedPacks.length > 0) {
                                    <div class="m-t-b-40-15">
                                      <div class="in collapse fx-col" aria-expanded="true" aria-hidden="false">
                                        @for (item of getItems('pack'); track item; let i = $index) {
                                          <div
                                            class="items m-t-5 md-no-proxy md-with-secondary _md fx-row fx-flex-100-in-col">
                                            <div class="cart-items__images fx-flex-30">
                                              <img class="img-avatar"
                                                [src]="configService.localSettings.Disco.DiscoUrl+ '/CMS/images/inventory' + getImage(item)"
                                                [default]="'assets/images/noimage.png'">
                                              </div>
                                              <div class="md-list-item-text layout-column p-t-8 fx-col fx-flex-67">
                                                @if (item.ProductName !== 'Enrollment Fee') {
                                                  <h3 class="product_detail_text1 color3-f-s-13"
                                                    [textContent]="item.ProductName | slice:0:40"
                                                    matTooltip="{{item.ProductName}}"
                                                  ></h3>
                                                }
                                                @if (item.ProductName === 'Enrollment Fee') {
                                                  <h3 class="product_detail_text1 color3-f-s-13"
                                                    matTooltip="{{item.ProductName}}"
                                                  >{{"enrollment_fee" | translate}}</h3>
                                                }
                                                @if (item.selectedOptions) {
                                                  <span class="f-s-12"
                                                  [textContent]="item.selectedOptions"></span>
                                                }
                                                <!-- <p class="product_detail_qv  m-b-0">{{'global_pv'|translate}}<span> :
                                              {{item.Quantity * (item.CV || item.QV || 0)}}</span>
                                            </p> -->
                                          </div>
                                          <div class="fx-flex-2">
                                            <div class="md-secondary-container">
                                              <div class="price_set">
                                                <p
                                                  [textContent]="(item.Quantity * item.Price) | currency: companyService.selectedCurrency.CurrencyCode">
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                  <!-- <mat-expansion-panel>
                                  <mat-expansion-panel-header>
                                    <div fxLayout="row" fxFlex="100">
                                      <div fxLayout="column" fxFlex="80">
                                        <div>
                                          <span class="color3-f-s-13"
                                          translate="unifiedapplication_shop_kit_order"></span>
                                        </div>
                                        <div>
                                          <span class="itemCount" translate="unifiedapplication_sub_total"></span>
                                          <span class="itemCount"
                                          [textContent]="': (' + getPacksQuanity()+ ' items)'"></span>
                                        </div>
                                      </div>
                                      <div fxFlex="20" fxLayoutAlign="none end" fxLayout="column">
                                        <div *ngIf="orderService.packTotal">
                                          <span class="itemCount"
                                          [textContent]="orderService.packTotal | currency: companyService.selectedCurrency.CurrencyCode"></span>
                                        </div>
                                        <div>
                                          <span class="itemCount" translate="unifiedapplication_global_pv"></span>
                                          <span class="itemCount"
                                          [textContent]="' : ' + (orderService.packBusinessVolume || 0)"></span>
                                        </div>
                                      </div>
                                    </div>
                                  </mat-expansion-panel-header>
                                  <div fxLayout="column" class="in collapse borderTop" aria-expanded="true"
                                    aria-hidden="false">
                                    <div fxLayout="row" *ngFor="let item of getItems('pack'), let i = index"
                                      class="items m-t-5 md-no-proxy md-with-secondary _md" fxFlex="100">
                                      <div class="cart-items__images" fxFlex="30">
                                        <img class="img-avatar"
                                          [src]="configService.localSettings.Disco.DiscoUrl+ '/CMS/images/inventory' + getImage(item)"
                                          [default]="'assets/images/noimage.png'">
                                        </div>
                                        <div class="md-list-item-text layout-column p-t-8" fxLayout="column"
                                          fxFlex="67">
                                        <h3 class="product_detail_text1 color3-f-s-13"
                                          [textContent]="item.ProductName | slice:0:40"
                                        matTooltip="{{item.ProductName}}"></h3>
                                        <span class="f-s-12" *ngIf="item.selectedOptions"
                                        [textContent]="item.selectedOptions"></span>
                                        <p class="product_detail_qv  m-b-0">{{'global_pv'|translate}}<span> :
                                        {{item.Quantity * (item.CV || item.QV || 0)}}</span>
                                      </p>
                                    </div>
                                    <div fxFlex="8">
                                      <div class="md-secondary-container">
                                        <div class="price_set">
                                          <p
                                            [textContent]="(item.Quantity * item.Price) | currency: companyService.selectedCurrency.CurrencyCode">
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </mat-expansion-panel> -->
                              <mat-divider></mat-divider>
                            </div>
                          }
                          <!-- Section For Orders Items -->
                          @if (itemsService.selectedOrderItems.length > 0) {
                            <div class="m-t-b-15">
                              <mat-expansion-panel>
                                <mat-expansion-panel-header class="fx-row-in-expansion-header">
                                  <div class="fx-row fx-flex-100">
                                    <div class="fx-col fx-flex-80">
                                      <div>
                                        <span class="color3-f-s-13"
                                        translate="unifiedapplication_initial_order"></span>
                                      </div>
                                      <div>
                                        <span class="itemCount" translate="unifiedapplication_sub_total"></span>
                                        <span class="itemCount"
                                        [textContent]="': (' + getOrderQuanity()+ ' items)'"></span>
                                      </div>
                                    </div>
                                    <div class="fx-col fx-main-start fx-cross-end fx-flex-20">
                                      @if (orderService.orderTotal) {
                                        <div>
                                          <span class="itemCount"
                                          [textContent]="orderService.orderTotal ? orderService.orderTotal : 0 | currency: companyService.selectedCurrency.CurrencyCode"></span>
                                        </div>
                                      }
                                      <div>
                                        <span class="itemCount"
                                        translate="unifiedapplication_global_pv"></span><span
                                        class="itemCount"
                                      [textContent]="' : ' + (orderService?.orderBusinessVolume || 0)"></span>
                                    </div>
                                  </div>
                                </div>
                              </mat-expansion-panel-header>
                              <div class="in collapse borderTop fx-col" aria-expanded="true"
                                aria-hidden="false">
                                @for (item of getItems('order'); track item) {
                                  <div
                                    class="items m-t-5 md-no-proxy md-with-secondary _md fx-row fx-flex-100-in-col">
                                    <div class="cart-items__images fx-flex-30">
                                      <img class="img-avatar"
                                        [src]="configService.localSettings.Disco.DiscoUrl+ '/CMS/images/inventory' + getImage(item)"
                                        alt="'assets/images/noimage.png'">
                                      </div>
                                      <div class="md-list-item-text layout-column p-t-8 fx-col fx-flex-67"
                                        >
                                      <h3 class="product_detail_text1 color3-f-s-13"
                                        [textContent]="item.ProductName | slice:0:40"
                                      [matTooltip]="item.ProductName"></h3>
                                      @if (item.selectedOptions) {
                                        <span class="f-s-12"
                                        [textContent]="item.selectedOptions"></span>
                                      }
                                      <p class="product_detail_qv  m-b-0">{{'global_pv'|translate}}<span> :
                                      {{item.Quantity * (item.CV || item.QV || 0)}}</span>
                                    </p>
                                    <div class="input-group fx-row fx-main-center fx-cross-center">
                                      <span class="input-group-btn">
                                        <button mat-button-icon class=""
                                          (click)="decreaseQuantiy('order', item);closeCart()"
                                          type="button">
                                          <mat-icon class="c-gray">remove</mat-icon>
                                        </button>
                                      </span>
                                      <input type="text"
                                        [(ngModel)]="getQuantityModel('order', item)[item.ItemID]"
                                        (change)="checkQuantity('order', item); closeCart()"
                                        (keyup)="($event.which === 38) ? increaseQuantiy('order', item) : 0"
                                        (keydown)="($event.which === 40) ? decreaseQuantiy('order', item) : 0 ; closeCart()"
                                        (keypress)="getLastQuantity('order', item)"
                                        (ngInit)="getQuantityModel('order', item)[item.ItemID] ? getQuantityModel('order', item)[item.ItemID] : getQuantityModel('order', item)[item.ItemID] = 1"
                                        class="input-control" validate inputonlynumber="true" maxlength="2"
                                        aria-invalid="false">
                                      <span class="input-group-btn">
                                        <button mat-button-icon (click)="increaseQuantiy('order', item)"
                                          type="button">
                                          <mat-icon class="c-gray">add</mat-icon>
                                        </button>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </mat-expansion-panel>
                          <mat-divider></mat-divider>
                        </div>
                      }
                      <!--order total starts here-->
                      @if (itemsService.selectedOrderItems.length > 0 || itemsService.selectedPacks.length > 0) {
                        <div class="m-l-48 fx-col fx-flex-100-in-col"
                          >
                          <div class="fx-row fx-flex-100-in-col">
                            <div class="fx-flex-40">
                              <span class="itemCount" translate="unifiedapplication_sub_total"></span>
                            </div>
                            <div class="fx-row fx-main-end fx-cross-stretch fx-flex-60">
                              <span class="itemCount"
                              [textContent]="((orderService.calculateOrderResponse.SubTotal) ? (orderService.calculateOrderResponse.SubTotal) : 0) | currency: companyService.selectedCurrency.CurrencyCode"></span>
                            </div>
                          </div>
                          <div class="fx-row fx-flex-100-in-col">
                            <div class="fx-flex-40">
                              <span class="itemCount" translate="unifiedapplication_discounttotal"></span>
                            </div>
                            <div class="fx-row fx-main-end fx-cross-stretch fx-flex-60">
                              <span class="itemCount"
                              [textContent]="((orderService.calculateOrderResponse.DiscountTotal) ? (orderService.calculateOrderResponse.DiscountTotal) : 0) |currency:companyService.selectedCurrency.CurrencyCode"></span>
                            </div>
                          </div>
                          <div class="fx-row fx-flex-100-in-col">
                            <div class="fx-flex-40">
                              <span class="itemCount" translate="unifiedapplication_taxtotal"></span>
                            </div>
                            <div class="fx-row fx-main-end fx-cross-stretch fx-flex-60">
                              @if (!userService.taxError) {
                                <span class="itemCount"
                                [textContent]="((orderService.calculateOrderResponse.TaxTotal) ? (orderService.calculateOrderResponse.TaxTotal) : 0) |currency:companyService.selectedCurrency.CurrencyCode"></span>
                              }
                              @if (userService.taxError) {
                                <span class="itemCount"
                                [textContent]="('Check shipping state and zip')"></span>
                              }
                            </div>
                          </div>
                          <div class="fx-row fx-flex-100-in-col">
                            <div class="fx-flex-40">
                              <span class="itemCount" translate="unifiedapplication_global_total"></span>
                            </div>
                            <div class="fx-row fx-main-end fx-cross-stretch fx-flex-60">
                              <span class="itemCount"
                              [textContent]="((orderService.calculateOrderResponse.Total) ? (orderService.calculateOrderResponse.Total) : 0) |currency:companyService.selectedCurrency.CurrencyCode"></span>
                            </div>
                          </div>
                        </div>
                      }
                      <!-- Section For Autoship Items -->
                      @if (itemsService.selectedAutoOrderItems.length > 0) {
                        <div class="m-t-b-15">
                          <mat-expansion-panel>
                            <mat-expansion-panel-header class="fx-row-in-expansion-header">
                              <div class="fx-row fx-flex-100">
                                <div class="fx-col fx-flex-80">
                                  <div>
                                    <span class="color3-f-s-13"
                                    translate="unifiedapplication_autoship_order"></span>
                                  </div>
                                  <div>
                                    <span class="itemCount" translate="unifiedapplication_sub_total"></span>
                                    <span class="itemCount"
                                    [textContent]="': (' + getAutoOrderQuanity() + ' items)'"></span>
                                  </div>
                                </div>
                                <div class="fx-col fx-main-start fx-cross-end fx-flex-20">
                                  <div>
                                    <span class="itemCount"
                                    [textContent]="((orderService.calculateAutoOrderResponse.SubTotal ? (orderService.calculateAutoOrderResponse.SubTotal - orderService.calculateAutoOrderResponse.DiscountTotal) : 0) | currency:companyService.selectedCurrency.CurrencyCode)"></span>
                                  </div>
                                  <div>
                                    <span class="itemCount"
                                    translate="unifiedapplication_global_pv"></span><span
                                    class="itemCount">
                                    :
                                    {{(orderService?.autoorderBusinessVolume ||
                                  0)}}</span>
                                </div>
                              </div>
                            </div>
                          </mat-expansion-panel-header>
                          <div class="in collapse borderTop fx-col" aria-expanded="true"
                            aria-hidden="false">
                            @for (item of getItems('autoship'); track item) {
                              <div
                                class="items m-t-5 md-no-proxy md-with-secondary _md fx-row fx-flex-100-in-col">
                                <div class="cart-items__images fx-flex-30">
                                  <img class="img-avatar"
                                    [src]="configService.localSettings.Disco.DiscoUrl+ '/CMS/images/inventory' + getImage(item)"
                                    [default]="'assets/images/noimage.png'">
                                  </div>
                                  <div class="md-list-item-text layout-column p-t-8 fx-col fx-flex-67"
                                    >
                                  <p class="product_detail_text1 color3-f-s-13"
                                    [textContent]="item.ProductName | slice:0:40"
                                  [matTooltip]="item.ProductName"></p>
                                  @if (item.selectedOptions) {
                                    <span class="f-s-12"
                                    [textContent]="item.selectedOptions"></span>
                                  }
                                  <p class="product_detail_qv  m-b-0">{{"unifiedapplication_global_pv" |
                                    translate}}<span> : {{item.Quantity * (item.CV ||
                                  item.QV || 0)}}</span>
                                </p>
                                <div class="input-group fx-row fx-main-center fx-cross-center">
                                  <span class="input-group-btn">
                                    <button mat-button-icon class="c-gray"
                                      (click)="decreaseQuantiy('autoship', item);closeCart();"
                                      type="button">
                                      <mat-icon>remove</mat-icon>
                                    </button>
                                  </span>
                                  <input type="text"
                                    [(ngModel)]="getQuantityModel('autoship',item)[item.ItemID]"
                                    (change)="checkQuantity('autoship', item); closeCart()"
                                    (keyup)="($event.which === 38) ? increaseQuantiy('autoship', item) : 0"
                                    (keydown)="($event.which === 40) ? decreaseQuantiy('autoship', item) : 0 ; closeCart()"
                                    (keypress)="getLastQuantity('autoship', item)"
                                    (ngInit)="getQuantityModel('autoship', item)[item.ItemID] ? getQuantityModel('autoship', item)[item.ItemID] : getQuantityModel('autoship', item)[item.ItemID] = 1"
                                    class="input-control" maxlength="2" validate=""
                                    inputonlynumber="true" aria-invalid="false">
                                  <span class="input-group-btn">
                                    <button mat-button-icon class=""
                                      (click)="increaseQuantiy('autoship', item)" type="button">
                                      <mat-icon class="c-gray">add</mat-icon>
                                    </button>
                                  </span>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </mat-expansion-panel>
                      <mat-divider></mat-divider>
                    </div>
                  }
                  @if (itemsService.selectedAutoOrderItems.length > 0) {
                    <div class="m-l-48 fx-col fx-flex-100-in-col"
                      >
                      <div class="fx-row fx-flex-100-in-col">
                        <div class="fx-row fx-main-start fx-cross-center fx-flex-12 sm-fx-flex-5 md-fx-flex-5">
                          <mat-icon class="c-gray" style="margin-bottom: 18px;" (click)="picker.open()">
                          calendar_today</mat-icon>
                        </div>
                        <div class="fx-flex-70">
                          <p class="itemCount">{{'unifiedapplication_autoship_order_note_freq' |
                            translate:{frequency:commonData.FrequencyTypes[persistentService.retailData.Autoship.FrequencyTypeID].Description}
                          }}</p>
                        </div>
                        <div class="fx-flex-20"></div>
                      </div>
                      <div class="fx-row fx-flex-60-in-col">
                        <div class="fx-row fx-flex-60">
                          <mat-form-field class="example-full-width fx-flex" appearance="outline">
                            <mat-label>Choose a date</mat-label>
                            <input matInput [matDatepicker]="picker"
                              [(ngModel)]="autoshipConfigurationService.autoshipDate"
                              [min]="AutoshipMinDate" [max]="AutoshipMaxDate" disabled>
                            <mat-datepicker-toggle matSuffix [for]="picker">
                              <mat-icon class="c-gray" matDatepickerToggleIcon>keyboard_arrow_down
                              </mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #picker disabled="false"
                              [startAt]="autoshipConfigurationService.autoshipDate">
                            </mat-datepicker>
                          </mat-form-field>
                        </div>
                        <div class="fx-flex-40"></div>
                      </div>
                      <div class="fx-row fx-flex-60-in-col">
                        <div class="fx-row fx-flex-100">
                          <mat-form-field class="fx-flex-83 xs-fx-flex-67 sm-fx-flex-60 md-fx-flex-60"
                            appearance="outline">
                            <mat-label translate="unifiedapplication_choose_frequency"></mat-label>
                            <mat-select [(ngModel)]="persistentService.retailData.Autoship.FrequencyTypeID"
                              (selectionChange)="setFrequency();">
                              @for (freq of commonData.FrequencyTypes; track freq) {
                                <mat-option
                                  [value]="freq.ID">
                                  {{freq.Description | translate}}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <mat-divider></mat-divider>
                <mat-action-row>
                  <div class="fx-col">
                    <div class="fx-col fx-main-center fx-cross-center fx-flex-100-in-col">
                      <div class="placeOrderButton">
                        <button mat-raised-button color="primary" validate trigger-check="true"
                          [disabled]="IsSubmitDisable" (success)="checkCvvModal()"
                          translate="">{{'unified_place_order' | translate}}
                        </button>
                      </div>
                      <div class="cards-available fx-gap-right-10px">
                        <img src="assets/images/visaa.png" alt="visa" width="50px">
                        <img src="assets/images/mastercard.png" alt="mastercard" width="50px">
                        <img src="assets/images/Discover.png" alt="“Discover”" width="50px">
                        <img src="assets/images/Amex.png" alt="americanexp" width="50px">
                      </div>
                      <div>
                        <p
                        [translate]="'cart_transactions_msg'">All transactions are processed in the USA.</p>
                      </div>
                    </div>
                    <hr class="gap-between">
                    <div class="m-b-10 policyblock fx-col fx-main-start fx-cross-start fx-flex-100-in-col">
                      <div class="fx-row fx-flex-100-in-col">
                        <div class="p-r-25 fx-row fx-main-start fx-cross-stretch fx-flex-7">
                          <mat-icon class="c-gray">
                            summarize
                          </mat-icon>
                        </div>
                        <div class="m-bb-10 fx-flex-80">
                          <span class="orderSummary" translate="unifiedapplication_pdf_section"></span>
                        </div>
                      </div>
                      <div class="m-ll-25 fx-flex-100-in-col">
                        <ul>
                          <li><a href="https://ew-customer-success.s3.amazonaws.com/Think_Plus/Operations/Terms+%26+Policies.pdf"
                            target="_blank"
                          [translate]="'policies_and_procedures'">Policies and Procedures</a>
                        </li>
                        <li><a href="https://ew-customer-success.s3.amazonaws.com/Think_Plus/Operations/Cancellation+Policy.pdf"
                          target="_blank"
                        [translate]="'cancellation_policy'">Cancellation Policy</a>
                      </li>
                      <li><a href="https://ew-customer-success.s3.amazonaws.com/Think_Plus/Operations/Refund+Policy.pdf"
                        target="_blank"
                      [translate]="'refund_policy_title'">Refund Policy</a>
                    </li>
                    <li><a href="https://ew-customer-success.s3.amazonaws.com/Think_Plus/Operations/Think%2B_Compensation_Plan.pdf"
                      target="_blank"
                    [translate]="'compensation_plan'">Compensation Plan</a>
                  </li>
                  <li><a href="https://ew-customer-success.s3.amazonaws.com/Think_Plus/Operations/Dispute+Resolution+and+Arbitration+Policy.pdf"
                    target="_blank"
                  [translate]="'arbitration_policy'">Arbitration Policy</a>
                </li>
                <li><a href="https://ew-customer-success.s3.amazonaws.com/Think_Plus/Operations/E-Sign+Consent.pdf"
                  target="_blank"
                [translate]="'esign_consent'">E-Sign Consent</a>
              </li>
              <li><a href="https://ew-customer-success.s3.amazonaws.com/Think_Plus/Operations/Website+Privacy+Policy.pdf"
                target="_blank"
              [translate]="'website_privacy_policy'">Website Privacy Policy</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </mat-action-row>
</mat-accordion>
</mat-card>
</div>
</div>
</div>
<script>
  function OnIFrameSave(e) {

}
</script>